// Compact 1–5 smiley rating shown after a claim is accepted or an
// authorization is approved. Clicking a face is optimistic — the parent
// fires the persist call in the background.

const FACES = [
    { score: 1, emoji: "😞", label: "Very bad" },
    { score: 2, emoji: "🙁", label: "Bad" },
    { score: 3, emoji: "😐", label: "Okay" },
    { score: 4, emoji: "🙂", label: "Good" },
    { score: 5, emoji: "😄", label: "Great" },
];

const OutcomeRating = ({ prompt, score, disabled, onRate }) => {
    const selected = Number(score);
    const rated = Number.isInteger(selected) && selected >= 1 && selected <= 5;
    const locked = rated || !!disabled;

    return (
        <div className={`agents-rating ${rated ? "is-rated" : ""}`}>
            <div className="agents-rating__prompt">
                {rated ? "Thanks — this helps the next claim." : (prompt || "How did this go?")}
            </div>
            <div
                className="agents-rating__faces"
                role="group"
                aria-label={rated ? "Rating submitted" : "Rate this result"}
                aria-disabled={locked}
            >
                {FACES.map((f) => {
                    const isOn = selected === f.score;
                    return (
                        <button
                            key={f.score}
                            type="button"
                            className={`agents-rating__face ${isOn ? "is-selected" : ""}`}
                            aria-label={`${f.label} (${f.score} of 5)`}
                            aria-pressed={isOn}
                            title={rated ? "Rating cannot be changed" : f.label}
                            disabled={locked}
                            onClick={() => {
                                if (locked) return;
                                onRate?.(f.score);
                            }}
                        >
                            <span aria-hidden="true">{f.emoji}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default OutcomeRating;
